export default function () {
  return {
    //
  };
}